<template>
  <div class="hzhb">
    <div class="banner">
      <img class=" banner_img" src="../../static/img/hz_banner.png" alt="">
    </div>
    <div class="content">
      <div class="content_hz w1200">
        <!-- 中国人保 -->
        <img @click="skip('http://www.epicc.com.cn/')" src="../../static/img/hzhb_zgrb.png" alt="">
        <!-- 中国平安 -->
        <img @click="skip('http://www.pingan.com')" src="../../static/img/hzhb_zgpa.png" alt="">
        <!-- 中华保险 -->
        <img @click="skip('http://www.cic.cn/')" src="../../static/img/hzhb_zhbx.png" alt="">
        <!-- 中国太平 -->
        <img @click="skip('http://www.cntaiping.com/')" src="../../static/img/hzhb_zgtp.png" alt="">
        <!-- 安盛天平 -->
        <img @click="skip('http://www.axatp.com')" src="../../static/img/hzhb_astp.png" alt="">
        <!-- 利宝保险 -->
        <img @click="skip('http://www.libertymutual.com.cn/')" src="../../static/img/hzhb_lbbx.png" alt="">
        <!-- 鼎和保险 -->
        <img @click="skip('http://www.edhic.com.cn/')" src="../../static/img/hzhb_dhbx.png" alt="">
        <!-- 紫金保险 -->
        <img @click="skip('http://www.zking.com/')" src="../../static/img/hzhb_zjbx.png" alt="">
        <!-- 大地保险 -->
        <img @click="skip('http://www.95590.cn')" src="../../static/img/hzhb_ddbx.png" alt="">
        <!-- 华安保险 -->
        <img @click="skip('https://www.sinosafe.com.cn/')" src="../../static/img/hzhb_habx.png" alt="">
        <!-- 众安保险 -->
        <img @click="skip('https://www.zhongan.com')" src="../../static/img/hzhb_zabx.png" alt="">
        <!-- 天安保险 -->
        <img @click="skip('http://www.95505.com.cn/')" src="../../static/img/hzhb_tabx.png" alt="">
        <!-- 华夏保险 -->
        <img @click="skip('http://www.ihxlife.com')" src="../../static/img/hzhb_hxbx.png" alt="">
        <!-- 百年人寿 -->
        <img @click="skip('http://www.aeonlife.com.cn/')" src="../../static/img/hzhb_bnrs.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hzhb',
  methods: {
    skip (url) {
      location.href = url
    },
     isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  },
  mounted () {
    if(this.isMobile()) {
          this.$router.push({ path: "/parnter" });
        } else {
          this.$router.push({ path: "/hzhb?page=5" });
        }
  }
}
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    max-width: 19.20rem;
    background-color: #024ea2;
    margin: 0 auto;
    position: relative;
    height: 12.96rem;
    .content_hz {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        box-sizing: border-box;
        padding: .5rem .1rem;
        position: absolute;
        background-color: #f2f2f2;
        left: 50%;
        transform: translateX(-50%) translateY(-0.45rem);
        height: 13.40rem;
        img {
            cursor: pointer;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Hzhb.vue